export const API_URL = process.env.REACT_APP_API_URL as string;
export const TITLE = process.env.REACT_APP_TITLE as string;
export const HEADER_ENV = process.env.REACT_APP_HEADER_ENV as string;
export const BASENAME = process.env.REACT_APP_BASENAME as string;
export const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const SPLIT_CODE = "@@@"; // selectの区切り文字

// 課金区分（無償）
export const CUSTOMER_PAYMENT_TYPE_FREE = "1";

// 承認ステータス
export const CUSTOMER_STATUS_UNAPPROVED = "1"; // 未承認
export const CUSTOMER_STATUS_APPROVAL = "2"; // 承認

// カテゴリ
export const CATEGORY_CODE_HISTORY = '01';
export const CATEGORY_CODE_SALES_APPLY = '02';

// カテゴリ権限
export const RESTRICTION_HISTORY_PROGRESS_NEW = '010100';
export const RESTRICTION_HISTORY_PROGRESS_NEW_NG = {label: '権限なし', value: 0};
export const RESTRICTION_HISTORY_PROGRESS_NEW_OK = {label: '権限あり', value: 1};
export const RESTRICTION_HISTORY_PROGRESS_DEL = '010101';
export const RESTRICTION_HISTORY_PROGRESS_DEL_NG = {label: '権限なし', value: 0};
export const RESTRICTION_HISTORY_PROGRESS_DEL_OK = {label: '権限あり', value: 1};
export const RESTRICTION_HISTORY_ATTRIBUTES_TAB = '010299';
export const RESTRICTION_HISTORY_ATTRIBUTES_TAB_HIDE = {label: '非表示', value: 0};
export const RESTRICTION_HISTORY_ATTRIBUTES_TAB_VIEW = {label: '閲覧のみ', value: 1};
export const RESTRICTION_HISTORY_ATTRIBUTES_TAB_EDIT = {label: '閲覧・編集', value: 2};
export const RESTRICTION_HISTORY_FILE = '010302';
export const RESTRICTION_HISTORY_FILE_HIDE = {label: '非表示', value: 0};
export const RESTRICTION_HISTORY_FILE_VIEW = {label: '閲覧のみ', value: 1};
export const RESTRICTION_HISTORY_FILE_EDIT = {label: '閲覧・編集（新作成・編集・削除）', value: 2};
export const RESTRICTION_HISTORY_USER = '011050';
export const RESTRICTION_HISTORY_USER_NG = {label: '権限なし', value: 0};
export const RESTRICTION_HISTORY_USER_OK = {label: '権限あり', value: 1};
export const RESTRICTION_HISTORY_DATA = '011151';
export const RESTRICTION_HISTORY_DATA_NG = {label: '権限なし', value: 0};
export const RESTRICTION_HISTORY_DATA_OK = {label: '権限あり', value: 1};

export const RESTRICTION_VALUES = {
  [RESTRICTION_HISTORY_PROGRESS_NEW]: [
    RESTRICTION_HISTORY_PROGRESS_NEW_NG,
    RESTRICTION_HISTORY_PROGRESS_NEW_OK,
  ],
  [RESTRICTION_HISTORY_PROGRESS_DEL]: [
    RESTRICTION_HISTORY_PROGRESS_DEL_NG,
    RESTRICTION_HISTORY_PROGRESS_DEL_OK,
  ],
  [RESTRICTION_HISTORY_ATTRIBUTES_TAB]: [
    RESTRICTION_HISTORY_ATTRIBUTES_TAB_HIDE,
    RESTRICTION_HISTORY_ATTRIBUTES_TAB_VIEW,
    RESTRICTION_HISTORY_ATTRIBUTES_TAB_EDIT,
  ],
  [RESTRICTION_HISTORY_FILE]: [
    RESTRICTION_HISTORY_FILE_HIDE,
    RESTRICTION_HISTORY_FILE_VIEW,
    RESTRICTION_HISTORY_FILE_EDIT,
  ],
  [RESTRICTION_HISTORY_USER]: [
    RESTRICTION_HISTORY_USER_NG,
    RESTRICTION_HISTORY_USER_OK,
  ],
  [RESTRICTION_HISTORY_DATA]: [
    RESTRICTION_HISTORY_DATA_NG,
    RESTRICTION_HISTORY_DATA_OK,
  ],
};

// attribute_settings
export const ATTRIBUTE_SETTING_IS_REQUIRED = '0010';
export const ATTRIBUTE_SETTING_LIMIT = '0020';
export const ATTRIBUTE_SETTING_DEFAULT_CODE = '0030';
export const ATTRIBUTE_SETTING_DEFAULT_VALUE = '0031';
export const ATTRIBUTE_SETTING_PARENT_ATTRIBUTE_ID = '0040';
export const ATTRIBUTE_SETTING_IS_AREA_RELATION = '0050';
export const ATTRIBUTE_SETTING_IS_BLOCK_RELATION = '0060';
export const ATTRIBUTE_SETTING_LIST_WIDTH = '0070';

// attribute_kinds_code
export const ATTRIBUTE_KINDS_CODE_TEXT_FIELD = '01';
export const ATTRIBUTE_KINDS_CODE_TEXT_AREA = '02';
export const ATTRIBUTE_KINDS_CODE_SELECT_BOX = '03';
export const ATTRIBUTE_KINDS_CODE_CHECK_BOX = '04';
export const ATTRIBUTE_KINDS_CODE_RADIO_BUTTON = '05';
export const ATTRIBUTE_KINDS_CODE_NUMBER_INT = '06';
export const ATTRIBUTE_KINDS_CODE_NUMBER_DECIMAL = '07';
export const ATTRIBUTE_KINDS_CODE_DATE = '08';

export const ATTRIBUTE_CODES = [ATTRIBUTE_KINDS_CODE_SELECT_BOX, ATTRIBUTE_KINDS_CODE_CHECK_BOX, ATTRIBUTE_KINDS_CODE_RADIO_BUTTON];
export const ATTRIBUTE_MULTIPLE_CODES = [ATTRIBUTE_KINDS_CODE_CHECK_BOX];

export const MESSAGE_NO_E08 = "必須項目です。";
export const MESSAGE_NO_P11 = "ログインIDまたはパスワードが違います。";
export const MESSAGE_NO_E35 = (num: number) => {
  return `${num}文字以内で入力してください。`;

}
export const MESSAGE_NO_E21 = "入力されたメールアドレスは利用できません。";
export const MESSAGE_NO_E36 = "「備考」は200字以内で入力してください。";
export const MESSAGE_NO_E37 = "データの保存に失敗しました。再度実行してください。";
export const MESSAGE_NO_E25 = "システムからログアウトしますか？";
export const MESSAGE_NO_E39 = "データの取得に失敗しました。再度実行してください。";
export const MESSAGE_NO_E41 = "コメントを送信してよろしいでしょうか？";
export const MESSAGE_NO_E66 = "コメントを入力してください。";

export const IS_AGREE = ["同意しない", "同意する"];
export const IS_USE = ["利用しない", "利用する"];
export const IS_BILLING_FLG = [
  {
    value: '0',
    label: '対象外',
  },
  {
    value: '1',
    label: '対象',
  },
]
export const CUSTOMER_STATUS = [
  {
    value: '1',
    label: '未承認',
  },
  {
    value: '2',
    label: '承認',
  },
]
export const BUSINESS_ENTITY_TYPE = [
  {
    value: '1',
    label: '法人',
  },
  {
    value: '2',
    label: '個人事業主',
  },
]
export const BILLING_POST_TYPE = [
  {
    value: '1',
    label: '申込者と同じ',
  },
  {
    value: '2',
    label: '上記以外',
  },
]
export const SET_BILLING_POST_ADDR = [
  {
    value: '0',
    label: '使用しない',
  },
  {
    value: '1',
    label: '使用する',
  },
]
export const PAYMENT_METHOD = [
  {
    value: '1',
    label: 'クレジットカード',
  },
  {
    value: '15',
    label: 'まるなげ口座振替',
  },
  {
    value: '16',
    label: 'まるなげバンクチェック',
  },
]
export const CREDIT_STATUS = [
  {
    value: '0',
    label: '却下',
  },
  {
    value: '1',
    label: '承認',
  },
  {
    value: '2',
    label: '申請中',
  },
]
export const USE_METHOD = [
  {
    value: '1',
    label: '都度APIを利用',
  },
  {
    value: '2',
    label: 'DLデータを利用',
  },
]

export const USE_PURPOSE = [
  {
    value: '1',
    label: 'xROAD道路管理者システム開発',
  },
  {
    value: '2',
    label: '他の道路管理システム（個別GIS）との連携のため',
  },
  {
    value: '3',
    label: '他の道路管理以外のシステムとの連携のため',
  },
  {
    value: '6',
    label: '道路管理業務の確認の為',
  },
  {
    value: '7',
    label: 'RI2MAPS',
  },
  {
    value: '8',
    label: 'その他の目的の為',
  },
]
export const USE_PURPOSE2 = [
  {
    value: '1',
    label: 'xROAD道路管理者発注のシステム開発',
  },
  {
    value: '4',
    label: '道路管理者発注のシステム開発',
  },
  {
    value: '5',
    label: '自社開発のシステム開発',
  },
  {
    value: '6',
    label: '道路管理業務の確認の為',
  },
  {
    value: '7',
    label: 'RI2MAPS',
  },
  {
    value: '8',
    label: 'その他の目的の為',
  },
];
export const SYSTEM_STRUCTURE = [
  {
    value: '1',
    label: '1.据置ナビ',
  },
  {
    value: '2',
    label: '2.PND',
  },
  {
    value: '3',
    label: '3.スマホ組込み',
  },
  {
    value: '4',
    label: '4.システム',
  },
  {
    value: '5',
    label: '5.電子地図',
  },
  {
    value: '6',
    label: '6.センター地図型',
  },
];

//
export enum Data {
  AttributeNew,
  AttributeEdit,
  AttributeCopy,
  AttributeDetail,
  ApplyAreaList,
  ApplyAreaListEdit,
  FileNew,
  FileEdit,
  FileList,
}

export enum Tab {
  Attribute,
  ApplyArea,
  File,
}

export const tab = (isType: Data) => {
  switch (isType) {
    case Data.AttributeNew:
    case Data.AttributeEdit:
    case Data.AttributeCopy:
    case Data.AttributeDetail:
      return Tab.Attribute;
    case Data.ApplyAreaList:
    case Data.ApplyAreaListEdit:
      return Tab.ApplyArea;
    case Data.FileNew:
    case Data.FileEdit:
    case Data.FileList:
      return Tab.File;
  }
};

export const isAttribute = (isType: Data) => {
  switch (isType) {
    case Data.AttributeNew:
    case Data.AttributeEdit:
    case Data.AttributeCopy:
    case Data.AttributeDetail:
      return true;
    case Data.FileNew:
    case Data.FileEdit:
    case Data.FileList:
      return false;
  }
};

export const isAttributeNew = (isType: Data) => {
  switch (isType) {
    case Data.AttributeNew:
    case Data.AttributeCopy:
      return true;
    default:
      return false;
  }
};

export enum Forgot {
  LoginId = "LoginId",
  Password = "Password",
}